import React, { useEffect, useState } from "react";
import Pusher from "pusher-js";
import moment from "moment-timezone";
//components
import Captcha from "./captcha";
import BookingPage from "./bookingpage";
import Topbar from "../../components/topbar/topbar";
import Footer from "../client/appointment/footer";
import BookingConfirm from './bookingconfirm';

//css
import "./booking.css";
import ClientForm from "./clientform";
import { toast } from "react-toastify";
import { createGuestBooking } from "../../services/client";
import { useParams } from "react-router-dom";
import { setLoading } from "../../reducer/auth/auth";
import { useDispatch, useSelector } from "react-redux";
import Questions from "./questions";
import PayOptionsPopUp from "./payment";
import { getCountry, getLanguages } from "../../services/uidata";
import TimeZoneCofirmPopup from "../profile/timeZoneConfirmPopup";
import TimeZonePopup from "../profile/timeZonePopup";
import { getTimeZoneFromCountry } from "../../services/auth";
import CountryTimeZoneSelection from "../profile/countryTimeZoneSelection";
import ConfirInterviewModal from "./confirminterviewmodal";
import { use } from "react";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";

export default function CheckInService() {
    const { t } = useTranslation("checkIn");
    const navigate = useNavigate();
    const { email } = useSelector(
        (state) => state.user.user
    );
    const auth = useSelector((state) => state.auth);
    const params = useParams();
    const dispatch = useDispatch();
    const [stateType, setStateType] = useState("calendar");
    const [bookingDate, setBookingDate] = useState("");
    const [bookingTime, setBookingTime] = useState("");
    const [timezoneInfo, setTimeZoneInfo] = useState("");
    const [session_id, setsession_id] = useState("");
    const [subsession_id, setsubsession_id] = useState("");
    const [slotDetails, setslotDetails] = useState({})
    const [userDetails, setuserDetails] = useState({})
    const [timezoneData, setTimezoneData] = useState([]);
    const [price, setPrice] = useState('');
    const [duration, setDuration] = useState('');
    const [currency, setCurrency] = useState('');

    const [timeZoneName, setTimeZoneName] = useState('');

    const [timeZoneLocalName, setTimeZoneLocalName] = useState('');
    //
    const [paymentInfo, setPaymentInfo] = useState();
    const [counterStatus, setCounterStatus] = useState(false);
    const [formLanguages, setFormLanguages] = useState([]);
    const [countryData, setCountryData] = useState([]);
    const [temporaryStorage, setTemporaryStorage] = useState({});
    const [disableTime, setDisableTime] = useState('');
    const [countryName, setcountryName] = useState('');
    const [clientFirstName, setClientFirstName] = useState('');
    const [countrySpecifiedTimeZone, setCountrySpecifiedTimeZone] = useState([

    ]);
    const [CurrentDate, setCurrentDate] = useState(moment().format('hh:mm A'))
    const usTimeZones =
        ["(GMT-5:00) Eastern Standard Time - New York",
            "(GMT-5:00) Eastern Standard Time - East-Indiana",
            "(GMT-6:00) Central Standard Time - Chicago",
            "(GMT-9:00) Alaska Standard Time - Alaska",
            "(GMT-10:00) Hawaii Standard Time - Honolulu",
            "(GMT-11:00) Samoa Standard Time - Midway",
            "(GMT-06:00) Central Standard Time - Chicago",
            "(GMT-05:00) Eastern Standard Time - New_York"
        ]
    const canadaTimeZones = ["(GMT-3:30) Newfoundland Standard Time - Newfoundland",
        "(GMT-4:00) Atlantic Standard Time - Atlantic",
        "(GMT-5:00) Eastern Standard Time - New York",
        "(GMT-6:00) Central Standard Time - Saskatchewan",
        "(GMT-6:00) Central Standard Time - Chicago",
        "(GMT-06:00) Central Standard Time - Chicago",
    ]
    useEffect(() => {
        if(auth.auth){
           window.location.href = "/login?check-in-service";
        }
    }, []);
    const updateLanguage = () => {
        getLanguages()
            .then((data) => {
                setFormLanguages(data.data.data);
            })
            .catch((err) => console.log(err));
    };

    const updateCountries = () => {
        getCountry()
            .then((data) => {
                setCountryData(data.data.data);
            })
            .catch((err) => console.log(err));
    };

    const onChange = (value) => {
        setTimeout(() => {
            setStateType("questions");
        }, 2000);
    };
    const openForm = (info) => {
        setClientFirstName(info.clientName);
        if (bookingDate === "" || bookingTime === "") {
            toast.error(t("booking.selectDateAndSlot"), {
                position: "top-center",
            });
            return;
        }
        createBooking(info)
        // if (parseInt(session_id) !== 7) {
        //     window.loadModal2("#payoptionspopupguestBooking", "show");
        // }
        // else {
        //     let item = {

        //         paymenttype: '',
        //     };
        //     createBooking(item);
        // }
        dispatch(setLoading(true))
        setTimeout(() => {
            dispatch(setLoading(false))
            
        }, 1000)
    };

    const createBooking = (info) => {
        

        let body = {
            email: info.email,
            timezone: timezoneInfo,
            date: bookingDate,
            time: bookingTime,
            session_id: session_id,
            subsession_id: subsession_id,
            medium_id: info.medium_id,
            amount: 0,
           
        }
        dispatch(setLoading(true));
        setDisableTime('')
        createGuestBooking(body)
            .then((data) => {
                console.log(data, body);
                setTimeout(() => {
                    if (data.data.status) {
                        setCounterStatus(true)
                        dispatch(setLoading(false));
                        setslotDetails(data.data.data)
                       // window.open(data.data.data.approvedUrl, "_self");
                        window.loadModal("#interviewConfirmbooking", "open");
                    }
                    else {
                    toast.error(data.data.message, {
                        position: "top-center",
                    });
                        dispatch(setLoading(false));
                    }
                }, 1000)
            })
            .catch(() => { dispatch(setLoading(false)); });
    };

    //
    const confirmRequest = (values) => {
        let value = values == "" ? temporaryStorage : values;
        window.loadModal2('#TimeZonePopup', 'hide');
        console.log(value);
        dispatch(setLoading(true));
        createGuestBooking(value)
            .then((data) => {
                console.log(data, value);
                setTimeout(() => {

                    if (data.data.status && parseInt(session_id) === 7) {
                        dispatch(setLoading(false));
                        setslotDetails(data.data.data)
                        setuserDetails(value)
                        setStateType("confirm");
                    }
                    else if (data.data.status && parseInt(session_id) !== 7) {
                        setCounterStatus(true)
                        dispatch(setLoading(false));
                        window.open(data.data.data.approvedUrl, "_self");
                        // setslotDetails(data.data.data.data)
                        setuserDetails(value)
                        // setStateType("confirm");

                        // window.loadModal2('#WaitingTimerPopup', 'show');
                    }
                    else {
                        dispatch(setLoading(false));
                    }
                }, 1000)
            })
            .catch(() => { dispatch(setLoading(false)); });
    }
    const cancelRequest = () => {
        window.loadModal2('#TimeZoneCofirmPopup', 'hide');
        window.loadModal2('#TimeZonePopup', 'show');
    }

    const confirmNewTimeZone = (value) => {
        console.log(temporaryStorage, "temporaryStorage", value);

        let newValue = {
            ...temporaryStorage,
            timezone: parseInt(value),
        }
        console.log(newValue, newValue)
        confirmRequest(newValue)
    }
    //
    useEffect(() => {
        localStorage.removeItem('guest_id');
    //      localStorage.clear();
    // sessionStorage.clear();
        updateCountries();
        updateLanguage();

    }, [])

    return (
        <>
            <div className="new-appointment new-appointment-listt pb-5">
                <Topbar />
                {/* {stateType === "captcha" && <Captcha onChange={onChange} />}
            {stateType === "questions" && <Questions setStateType={setStateType} />} */}
                {stateType === "calendar" && (
                    <BookingPage
                        openForm={openForm}
                        setBookingDate={setBookingDate}
                        setBookingTime={setBookingTime}
                        setTimeZoneInfo={setTimeZoneInfo}
                        setsession_id={setsession_id}
                        setsubsession_id={setsubsession_id}
                        setTimeZoneName={setTimeZoneName}
                        setTimeZoneLocalName={setTimeZoneLocalName}
                        price={price}
                        currency={currency}
                        setPrice={setPrice}
                        setDuration={setDuration}
                        setPaymentInfo={setPaymentInfo}
                        setCurrency={setCurrency}
                        timezoneData={timezoneData}
                        setTimezoneData={setTimezoneData}
                       
                    />
                )}
                {stateType === "form" && <ClientForm createBooking={createBooking}
                    bookingTime={bookingTime}
                    bookingDate={bookingDate}
                    timeZoneName={timeZoneName}
                    paymentInfo={paymentInfo}
                    session_id={session_id}
                    subsession_id={subsession_id}
                    medium_id={params.id}
                    price={price}
                    duration={duration}
                    setCounterStatus={setCounterStatus}
                    counterStatus={counterStatus}
                    formLanguages={formLanguages}
                    countryData={countryData}

                />}
                {stateType === "confirm" && <BookingConfirm slotDetails={slotDetails} userDetails={userDetails} />}
                <PayOptionsPopUp paymentInfo={paymentInfo} createBooking={createBooking} />
                <ConfirInterviewModal slotDetails={slotDetails} clientFirstName={clientFirstName}/>
                <div className="text-center pb-5 mt-5 pt-5 padding-botton-120px">
                    <Footer />
                </div>

            </div>


            <TimeZoneCofirmPopup confirmRequest={confirmRequest} cancelRequest={cancelRequest} id={"TimeZoneCofirmPopup"} />
            <div className="text-center">
                <TimeZonePopup newTimezoneData={timezoneData} confirmNewTimeZone={confirmNewTimeZone} disableTime={disableTime} CurrentDate={CurrentDate} />
            </div>
            <CountryTimeZoneSelection
                confirmNewTimeZone={confirmNewTimeZone}
                newTimezoneData={countrySpecifiedTimeZone}
                CurrentDate={CurrentDate}
                countryName={countryName}
            />
        </>
    );
}


